export default "__VITE_ASSET__hGM2YX9A__"